<!-- App.svelte -->
<script>
  import { Router, Route } from "svelte-routing";

  // Admin Layout
  import Admin from "./layouts/Admin.svelte";
  // Auth Layout
  import Auth from "./layouts/Auth.svelte";

  // No Layout Pages
  import Index from "./views/Index.svelte";
  import Landing from "./views/Landing.svelte";
  import Profile from "./views/Profile.svelte";
  import Logout from "./views/admin/Logout.svelte";

  import Survey from "./views/Survey.svelte";

  import { token } from './stores.js';
  $: isAuthenticated = $token;
  export let url = "";
</script>

<Router url="{url}">
  <!-- admin layout -->
  <Route path="admin/*admin" component="{Admin}" />
  <!-- auth layout -->
  <Route path="auth/*auth" component="{Auth}" />
  <!-- no layout pages -->
  <Route path="landing" component="{Landing}" />
  <Route path="profile" component="{Profile}" />
  {#if isAuthenticated}
    <Route path="/*admin" component="{Admin}" />
    {:else}
    <Route path="/*auth" component="{Auth}" />
  {/if}
  <Route path="/logout" component="{Logout}" />
  <Route path="/survey/:surveyId" let:params={surveyId} component="{Survey}"/>
</Router>
